import { isEmpty as _isEmpty } from 'lodash';

export default function notEmpty(value: any): boolean {
    return !_isEmpty(value);
}
